document.addEventListener("DOMContentLoaded", function () {
  // resize use cases based on the use case content height
  const tabs = document.querySelector("#tabs");
  const content = document.querySelector("#content");
  if (tabs && content) {
    const resizeObserver = new ResizeObserver((entries) => {
      for (let entry of entries) {
        const height = entry.target.clientHeight;
        tabs.style.height = height + "px";
      }
    });
    resizeObserver.observe(content);
  }
});
